// GENERATED FILE — do not edit, do not commit (see .gitignore).
// Written by frontend/scripts/generate-version.js on install and on every build.
export const buildInfo = {
  commit: '88e5392',
  branch: 'staging',
  buildDate: '2026-11-03T18:32:21.825Z',
  dirty: true,
} as const;
